<template>
  <tr v-if="order">
      <td> {{order.offer.name}}</td>
      <td> {{order.text}}</td>
      <td v-if="this.get_full_current_offer">
        <ul>
          <li>{{this.get_full_current_offer.distributed_product.agency.name}}</li>
          <li>{{this.get_full_current_offer.distributed_product.agency.street_line1}}</li>
          <li>{{this.get_full_current_offer.distributed_product.agency.street_line2}}</li>
          <li>{{this.get_full_current_offer.distributed_product.agency.street_zipcode}} {{this.get_full_current_offer.distributed_product.agency.city}}</li>
          <li>{{this.get_full_current_offer.distributed_product.agency.state}} {{this.get_full_current_offer.distributed_product.agency.decoded_country}}</li>
          <li>{{this.get_full_current_offer.distributed_product.agency.final_hotline_phone}}</li>
          <li>{{this.get_full_current_offer.distributed_product.agency.phone}}</li>
        </ul>

      </td>
      <td>
        {{order.decoded_requester_profile}}
      </td>
      <td> {{order.quantity}}</td>
      <td> {{order.price / 100 }} </td>
      <td>
        <ul v-for="(option, idx) in order.options">
          <li>{{option.name}}</li>
        </ul>
      </td>
      <td>
        {{order.contract_start_date | moment-date}}
      </td>
      <td>
          <button class="btn btn-warning" @click="$emit('deletesuborder', {suborder_id:order.id})">
              <i class="fa fa-trash-o" aria-hidden="true"></i> Supprimer
          </button>
      </td>
  </tr>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default
{
  props:["order"],

  computed:
  {
    ...mapState('catalog', ['offers']),

    get_full_current_offer(){
      var tmp = _.find(this.offers, (offer) => offer.id == this.order.offer.id)
      if (tmp == undefined)
        return false
      return tmp
    },

  },

  methods:{
    ...mapActions('catalog', ['get_full_offer_infos'])
  },

  created() {
    this.get_full_offer_infos(this.order.offer.id)
  }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// client/components/Catalog/Suborder.vue